import { Exclude, plainToInstance, Type } from 'class-transformer'
import { Guid } from 'guid-typescript'

import ActionNodeActions from '../index'
import { ActionTypes } from '../types'
import {
  PropertyValue,
  PropValueCalculate,
  PropValueConstant,
  PropValueNow,
  PropValueProperty
} from './PropertyActionValue'
import { PropertyActionType, SetPropertyActionValue } from './types'

export class PropertyAction extends ActionNodeActions<PropertyAction> {
  declare type: ActionTypes.Property
  property_index!: number | null
  action!: PropertyActionType
  @Type(() => PropertyValue, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: [
        { name: SetPropertyActionValue.Property, value: PropValueProperty },
        { name: SetPropertyActionValue.Calculate, value: PropValueCalculate },
        { name: SetPropertyActionValue.Constant, value: PropValueConstant },
        { name: SetPropertyActionValue.Now, value: PropValueNow },
      ]
    }
  })
  value!: PropertyValue
  @Exclude()
  guid: string = Guid.create().toString()

  getNewModel() {
    return plainToInstance(PropertyAction, {
      type: ActionTypes.Property,
      property_index: null,
      action: PropertyActionType.Inc,
      value: {
        type: null
      },
    })
  }
}
